<!--
  -  Copyright (c) Qwoach LLC 2023. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 1/1/2023
  -->

<template>
	<input ref="localInput"
		   v-bind="attrsStylesClass"
		   class="qw-file-picker-root"
		   v-if="!isFileLoading"
		   type="file"
		   @change="onFilePicked"
		   :accept="filter.join(',')"
		   :multiple="multiple">
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";
import {humanFileSize} from "@/utils/helpers";

export default {
	name: "LocalFilePicker",
	extends: BaseComponent,

	props: {
		filter: {Array, default: () => []},
		filterNames: {Array, default: () => []},
		sizeLimit: Number,
		loadFileOnSelect:{type: Boolean, default: true},
		multiple: Boolean,
	},

	data() {
		return {
			isFileLoading: false,
			fileManager: null
		}
	},

	mounted(){
		this.fileManager = this.$fileUploader.fileManager
	},


	methods: {
		pickFile(){
			this.$refs.localInput.click()
		},

		async onFilePicked(ev) {
			if(this.isFileLoading){
				return;
			}
			if(!ev.target){
				return
			}
			let fileInput = ev.target
			let filesArray = Array.from(fileInput.files || [])
			ev.target.value = null
			if(!filesArray.length){
				return;
			}
			let fileDataArray = await this.createSelectedFileDataArray(filesArray)
			if(fileDataArray.length === 1){
				this.$emit("fileSelected", fileDataArray[0].qwoachFile, fileDataArray[0].fileContent)
			} else if(fileDataArray.length > 1){
				this.$emit("filesSelected", fileDataArray)
			}
		},

		async createSelectedFileDataArray(filesArray) {
			let selectedFileDataArray = []
			this.setFileLoading(true)
			try {
				for(let file of filesArray){
					let fileData = await this.createSelectedFileData(file)
					if(fileData){
						selectedFileDataArray.push(fileData)
					}
				}
			} finally {
				this.setFileLoading(false)
			}
			return selectedFileDataArray
		},

		async createSelectedFileData(file) {
			let fileData = null
			let qwoachFile = this.fileManager.fileToQwoachFile(file)
			if(this.fileIsAllowed(file)){
				fileData = {qwoachFile}
				if(this.loadFileOnSelect){
					fileData.fileContent = await this.readFileAsDataUrl(file)
				}
			}
			return fileData
		},

		readFileAsDataUrl(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader()
				reader.onload = event => {
					resolve(event.target.result)
				}
				reader.onerror = event => {
					console.error(event)
					reject(event)
				}
				reader.readAsDataURL(file)
			})
		},

		fileIsAllowed(file) {
			let isAllowed = true
			if(!this.fileNameIsAllowed(file.name)){
				let filters = this.filterNames.length > 0 ? this.filterNames : this.filter
				console.log("filters = ", filters)
				this.toastWarn(`Only ${filters.join(", ")} files are allowed`)
				isAllowed = false
			}
			if(isAllowed && this.sizeLimit > 0 && file.size > this.sizeLimit){
				this.toastWarn("File is too big (" + humanFileSize(this.sizeLimit) + " max)")
				isAllowed = false
			}
			return isAllowed
		},

		setFileLoading(isLoading){
			let isChanged = isLoading !== this.isFileLoading
			this.isFileLoading = isLoading
			if(isChanged){
				this.$emit("loadingChanged", this.isFileLoading)
			}

		},

		fileNameIsAllowed(fileName){
			console.log("fileNameIsAllowed: ", fileName)
			if(this.filter.length === 0){
				return true
			}
			for(let filter of this.filter){
				if(fileName.toLowerCase().endsWith(filter)){
					console.log("fileNameIsAllowed: ends with ", filter)
					return true
				}
			}
			return false
		}
	},
}
</script>

<style lang="scss">

.qw-file-picker-root{
	//&input {
	//	position: absolute;
	//	top: 0;
	//	left: 0;
	//	z-index: -1;
	//	opacity: 0;
		visibility: hidden;
	//}
}

</style>
